<template>
    <div :class="[$style['mds-tag-container']]" :data-mds-version="version">
        <slot></slot>
    </div>
</template>

<script>
    import packageInfo from '../package.json';
    const { name, version } = packageInfo;

    export default {
        name: 'mds-tag-container',
        props: {
            version: {
                type: String,
                default: `${name}-${version}`,
            },
        },
    };
</script>

<style lang="scss" module>
    @import './tag-container.scss';
</style>
